var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgViewIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  fillRule: "evenodd",
  d: "M12 19.5c-2.433 0-4.65-.68-6.65-2.038C3.35 16.104 1.9 14.283 1 12c.9-2.283 2.35-4.104 4.35-5.463C7.35 5.18 9.567 4.5 12 4.5c2.433 0 4.65.68 6.65 2.037 2 1.359 3.45 3.18 4.35 5.463-.9 2.283-2.35 4.104-4.35 5.462-2 1.359-4.217 2.038-6.65 2.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  fillRule: "evenodd",
  d: "M12 17.5a9.545 9.545 0 0 0 5.188-1.488A9.773 9.773 0 0 0 20.8 12a9.773 9.773 0 0 0-3.613-4.013A9.545 9.545 0 0 0 12 6.5a9.545 9.545 0 0 0-5.188 1.487A9.773 9.773 0 0 0 3.2 12a9.773 9.773 0 0 0 3.612 4.012A9.545 9.545 0 0 0 12 17.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  fillRule: "evenodd",
  d: "M12 7.5c.86 0 1.63.207 2.313.62a2 2 0 1 0 2.147 3.246c.027.205.04.417.04.634 0 1.25-.438 2.313-1.313 3.188-.874.874-1.937 1.312-3.187 1.312-1.25 0-2.313-.438-3.188-1.313C7.939 14.313 7.5 13.25 7.5 12c0-1.25.438-2.313 1.313-3.188C9.687 7.939 10.75 7.5 12 7.5z"
}))));
export default SvgViewIcon;